import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Scroll from 'react-scroll';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import FieldDateTime from '../common/FieldDateTime';
import AttendanceAPI from '../../api/AttendanceAPI';
import ApiUiController from '../../controller/ApiUiController';
import ValidationController from '../../controller/ValidationController';
import Util from '../../util/Util';
import withRouter from '../../util/WithRouter';
import Const from '../../util/Constants';

class AttendanceUpdate extends React.Component {

  constructor(props) {
    super(props);
    this.id = parseInt(props.match.params.id);
    this.model = reactLocalStorage.getObject(Const.Model).attendance;
    this.state = { inApiCall: this.id !== 0, inValid: {}  };
    this.attendance = {};
    this.base = this.props.match.path
    this.base = this.base.substring(0, this.base.indexOf('/add-edit'));
  }

  componentDidMount() { if(this.id !== 0) { AttendanceAPI.get(this.id, this.onReceived, this.failure); } }

  failure = res => {
    Scroll.scroller.scrollTo(Object.keys(res)[0], { duration: 1500, smooth: true });
    const message = Util.failure(res);
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false, inValid: { ...res } });
  }

  onSave = () => {
    const inValid = ValidationController.validate(this.model.fields, this.attendance);
    if(inValid === null) {
      this.setState({ ...this.state, inApiCall: true });
      AttendanceAPI.save(this.attendance, this.onUpdateReceived, this.failure);
    } else {
      const message = Util.failure(inValid);
      Util.showError(message);
      Scroll.scroller.scrollTo(Object.keys(inValid)[0], { duration: 1500, smooth: true });
      this.setState({ ...this.state, inValid: { ...inValid } });
    }
  }
  onReceived = attendance => { this.attendance = attendance; this.setState({ inApiCall: false }); }
  onUpdateReceived=res=>this.props.navigate(`${this.base}/preview/${res.id}${this.saveLink}`);

  onValueChange = (field, value) => {
    this.attendance[field] = value;
    this.setState({ ...this.state, inValid: {} });
  }
  
  render() {
    return (
      <div className="sectionform">
        <div className="container form-cont">
          <ApiUiController inApiCall={this.state.inApiCall}>
            <Form className="row row-cols-3 lead-form">

              <FieldDateTime key="checkin" id="checkin" field={this.model.fields.checkin}
                value={this.attendance.checkin} onValueChange={this.onValueChange} inValid={this.state.inValid} />

              <FieldDateTime key="checkout" id="checkout" field={this.model.fields.checkout}
                value={this.attendance.checkout} onValueChange={this.onValueChange} inValid={this.state.inValid} />
              
              <div className="col-md-12 text-center btnsend">
                <Button className="buttons btn-success" onClick={this.onSave}>
                  { this.id === 0 ? 'Save' : 'Update' } Attendance
                </Button>
              </div>
            </Form>
          </ApiUiController>
        </div>
      </div>
    );
  }
}

export default withRouter(AttendanceUpdate);